import { render, staticRenderFns } from "./VerEditarModal.vue?vue&type=template&id=1bcbbe66&"
import script from "./VerEditarModal.vue?vue&type=script&lang=ts&"
export * from "./VerEditarModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1bcbbe66', component.options)
    } else {
      api.reload('1bcbbe66', component.options)
    }
    module.hot.accept("./VerEditarModal.vue?vue&type=template&id=1bcbbe66&", function () {
      api.rerender('1bcbbe66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/TiposProducto/VerEditarModal.vue"
export default component.exports